<form
    [formGroup]="form"
    class="d-inline-flex align-items-center sb-slide-toggle overflow-x-auto invisible-scroll mw-100"
    #formElement
    [class.sb-slide-toggle-boolean]="booleanMode"
    [class.sb-slide-toggle-off]="form.value?.value?.value === false"
    [class.sb-slide-toggle-on]="form.value?.value?.value === true"
    [class.sb-slide-toggle-disabled]="form.disabled || disabled"
>
    <ng-container *ngFor="let option of options">
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                [id]="id + option.value"
                formControlName="value"
                [value]="option"
                [class.active]="option.value === form.value?.value?.value"
                (change)="onChangeEvent($event)"
            />
            <label
                class="form-check-label text-center text-nowrap"
                [for]="id + option.value"
            >
                <tabler-icon
                    *ngIf="option.icon; else labelTmpl"
                    [name]="option.icon"
                    class="d-flex sb-icon-sm"
                ></tabler-icon>
                <ng-template #labelTmpl>{{ option.label }}</ng-template>
            </label>
        </div>
    </ng-container>
</form>
